import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SlickSlider from '../../Parts/SlickSlider'
import PropertyDetailBody from './PropertyDetailBody'
import Share from '../PropertyDetailModal/PropertyDetailBody/Share'
import { TransitionGroup } from 'react-transition-group';
import './styles.scss';

function PrevArrow(props) {
    const { onClick } = props;
    return (
        <div className={'prev-slide'} onClick={onClick} >
            <img src="/wp-content/themes/hayden/assets/images/icons/white-chev-left.svg" alt="chevron"/>
        </div>
    );
}

function NextArrow(props) {
    const { onClick } = props;
    return (
        <div className={'next-slide'} onClick={onClick} >
            <img src="/wp-content/themes/hayden/assets/images/icons/white-chev-right.svg" alt="chevron"/>
        </div>
    );
}
    
export default class PropertyDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agentSet: false,
            agent: {},
            secondaryAgentSet: false,
            secondaryAgent: {},
            updateCount: 0,
            slideIndex: 0,
            contact: false,
            // form fields
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            message: ''
        };
    }

    custAsNavFor = (i) => {
        this.slider1.slickGoTo(i)
        this.slider2.slickGoTo(i)
    }

    render() {
        // console.log({'DETAILS':this.props});
        return (
            <div id="test" className="PLEASE-WORK">
                    {
                        this.props.id &&

                        <div key={this.props.id} id={this.props.id} className={`property-details-takeover`}>
                        <div className="bg">
                            <img onClick={this.props.togglePropertyDetailsModal} className="close-takeover" src="/wp-content/themes/hayden/assets/images/icons/white-x-lrg.svg" alt="close form"/>
                            <div className="property-details-content-container">
                                <div className="details-header d-md-none">
                                    <button onClick={this.props.togglePropertyDetailsModal}>
                                        <img src="/wp-content/themes/hayden/assets/images/icons/green-chev-left.svg" alt="close chevron"/>
                                        Back
                                    </button>
                                    <Share
                                        property={this.props}
                                        favorites={this.props.favorites}
                                    />
                                </div>
                                <div className="slider-container">
                                    <SlickSlider
                                        images={this.props.images}
                                        settings={{
                                            dots: false,
                                            infinite: true,
                                            slidesToShow: 3,
                                            slidesToScroll: 1,
                                            lazyLoad: true,
                                            arrows: true,
                                            nextArrow: <NextArrow />,
                                            prevArrow: <PrevArrow />,
                                            responsive: [
                                                {
                                                breakpoint: 768,
                                                    settings: {
                                                        slidesToShow: 1
                                                }
                                                }
                                            ]
                                        }}
                                    />
                                </div>
                                <PropertyDetailBody 
                                    property={this.props} 
                                    modal="true"
                                    togglePropertyDetailsModal={this.props.togglePropertyDetailsModal}
                                    favorites={this.props.favorites}
                                    refreshUser={this.props.refreshUser}
                                />
                            </div>
                        </div>
                    </div>
                    

                    }
            </div>
        )
      }
};
